import Allcoin from './Allcoin';

export default Allcoin;
